module.exports = __webpack_public_path__ + "static/media/IE.2cd5aaeb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/ministries/IE.svg
// module id = 245
// module chunks = 0